import { useNavigate } from "react-router";

export function useRequiredURLSearchParam(key: string, redirectUrl: string) {
  const navigate = useNavigate();
  const param = new URLSearchParams(window.location.search).get(key);
  if (param === null) {
    navigate(redirectUrl);
    return "";
  }
  return param;
}
